<template>
  <v-card>
    <v-card-text
      class="pb-0"
    >
      <v-container
        fluid
        class="pb-0"
      >
        <v-row
          v-for="(item, index) in ticket.data.refill"
          :key="index"
          class="mb-1"
        >
          <h3 class="mr-1">{{ item.count }}x</h3>
          <h3>{{ item.label }}</h3>
          <v-spacer></v-spacer>
          <v-btn class="primary mr-2" :disabled="item.count===0" fab small @click="decrement(index)"><v-icon>mdi-minus</v-icon></v-btn>
          <v-icon class="mr-2">{{ item.icon }}</v-icon>
          <v-btn class="primary" fab small @click="increment(index)"><v-icon>mdi-plus</v-icon></v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="resetAll">
        <v-icon left>mdi-refresh</v-icon>
        Zurücksetzen
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
export default {
  name: "Refill",
  props: ["ticket"],
  data() {
    return {

    };
  },
  methods: {
    update(){
      this.$store.dispatch("update", {
        payload_type: "PUT",
        context: '/tickets/' + this.ticket.id + '/data', payload: this.ticket.data
      });
    },
    increment(index) {
      this.ticket.data.refill[index].count++;
      this.update()
    },
    decrement(index) {
      if (this.ticket.data.refill[index].count > 0) {
        this.ticket.data.refill[index].count--;
        this.update()
      }
    },
    resetAll() {
      this.ticket.data.refill.forEach(item => item.count = 0);
      this.update()
    }
  }
};
</script>

<style scoped>

</style>
